// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsGetTeamBody = {
  teamId: string;
};

export type typeNotificationSettingsGetTeamOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    isFollowing: boolean;
    alerts: {
      alertKindKey: "gameStart" | "gameEnd";
      isEnabled: boolean;
      isOnByDefault: boolean;
    }[];
  };
};

export type typeNotificationSettingsGetTeamOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetTeamOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetTeamOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsGetTeamBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsGetTeam(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsGetTeamBody);
  }

  return async function postNotificationSettingsGetTeam(
    payload: typeNotificationSettingsGetTeamBody,
  ): Promise<
    | typeNotificationSettingsGetTeamOutput200
    | typeNotificationSettingsGetTeamOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsGetTeam" failed before calling the network. #35ced0419d3c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#35ced0419d3c" },
        },
        data: null,
      } as typeNotificationSettingsGetTeamOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/get-team`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsGetTeamOutput200
      | typeNotificationSettingsGetTeamOutput400;
  };
}
